export default "__VITE_ASSET__DmnsDmUb__"